import { PoolShape } from "../../../constants/pool";
import RectImage from "../../../assets/rect.png";
import CircleImage from "../../../assets/pool-circle.png";
import KidneyImage from "../../../assets/pool-kidney.png";
import SquareImage from "../../../assets/pool-square.png";
import jsPDF from "jspdf";

export const getPoolImage = (pdf: jsPDF, shape: PoolShape): any => {
  if (shape === PoolShape.RECTANGULAR) {
    return pdf.addImage(RectImage, "PNG", 120, 132, 18, 10);
  } else if (shape === PoolShape.ROUND) {
    return pdf.addImage(CircleImage, "PNG", 120, 130, 15, 15);
  } else if (shape === PoolShape.KIDNEY) {
    return pdf.addImage(KidneyImage, "PNG", 120, 130, 25, 14);
  } else if (shape === PoolShape.SQUARE) {
    return pdf.addImage(SquareImage, "PNG", 110, 122, 30, 30);
  }
};
